import i18n from '@/utils/i18n';
import { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';

interface HiddenAlertActionHandlers {
  onDelete: (alert: Alert) => void;
  onRestore: (alert: Alert) => void;
}

export const hiddenAlertActions = (
  alert: Alert,
  { onDelete, onRestore }: HiddenAlertActionHandlers,
) => [
  {
    key: 'restore',
    label: i18n.t('insights_hub.action_sheet.restore'),
    onPress: () => onRestore(alert),
  },
  {
    key: 'delete',
    label: i18n.t('delete'),
    onPress: () => onDelete(alert),
  },
];
